import { baseApi } from "api/BaseApi";

import { CsComponent } from "../cscomponent.types";

const CS_COMPONENT_PROJ_BASE_URL = "cs/proj";

const csComponentProjApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCsComponentProjByPid: build.query<CsComponent[], string | number>({
      query: (productId) => ({
        url: `${CS_COMPONENT_PROJ_BASE_URL}/get_cscomponentproj_by_pid`,
        params: { pid: productId },
      }),
    }),
    deleteCsComponentProj: build.mutation<
      void,
      { cscid: string | number; pid: string | number }
    >({
      query: ({ cscid, pid }) => ({
        url: `${CS_COMPONENT_PROJ_BASE_URL}/remove_cs_proj/`,
        method: "POST",
        body: { cscid, pid },
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetCsComponentProjByPidQuery,
  useDeleteCsComponentProjMutation,
} = csComponentProjApi;
